/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 788
// module chunks = 3